import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PartCategory } from '../../opc-app/partcategory/partcategory.model';
import { PartGroup } from '../../opc-app/partgroup/partgroup.model';
import { Subject } from 'rxjs/Subject';
import { EnvironmentSettings } from '../models/environmentsettings.model';
import { Part } from '../../opc-app/part/part.model';
import { FormGroup } from '@angular/forms';

@Injectable()
export class PartService {
    searchedPart = new Subject<string>();
    environmentSettings: EnvironmentSettings;
    constructor(private _http: HttpClient) {
        this.environmentSettings = new EnvironmentSettings();
    }
    getPartsByGroupId(partGroupID: number): Observable<any> {
        return Observable.of('');
    }
    getPartDetailsByPartGroupId(id: number): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/partdetails/GetPartDetails/' + id);
    }
    getAllPartsByPartGroupId(id: number): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/partdetails/GetAllParts/' + id);
  }
  getAllPartsToExport(): Observable<any> {
    
    return this._http.get(this.environmentSettings.apiEndPoint +'api/partdetails/GetAllPartsToExport/');
  }

    addOrUpdatePart(part: Part, isNew: any): Observable<any> {
        let urlPath = '';
        if (!isNew) {
            urlPath = 'api/partdetails/AddPart';
        } else {
            urlPath = 'api/partdetails/UpdatePart';
        }
        return this._http.post(this.environmentSettings.apiEndPoint + urlPath, part);
    }
    deletePart(item: number): Observable<any> {
        return this._http.post(this.environmentSettings.apiEndPoint + 'api/partdetails/DeletePart', item);
    }
    verifyPartNumbers(partNumber: string): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/partdetails/IsValidPartNumber/' + partNumber);
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/part.service.ts